import { DocumentTransform } from '@apollo/client';
import { visit } from 'graphql';
const REQUIRED_BY_SYSTEM = ['id', 'entityId', 'entityType', 'name', 'parentId'];
function shouldKeepField(fieldName, columns) {
    return columns.includes(fieldName);
}
/**
 * Remove all fields that are not in the columns array, and keep all fields that are required by the system.
 * This function will modify the GraphQL document before sending it to the API.
 */
export function documentTransform(options) {
    const { columns } = options;
    let insideResults = false;
    const columnsToKeep = [...REQUIRED_BY_SYSTEM, ...columns];
    return new DocumentTransform((document) => visit(document, {
        Field: {
            // Track when we enter the 'results' field
            enter(field) {
                if (field.name.value === 'results' && insideResults === false) {
                    insideResults = true;
                }
            },
            leave(field) {
                // Track when we leave the 'results' field
                if (field.name.value === 'results') {
                    insideResults = false;
                }
                if (insideResults && !shouldKeepField(field.name.value, columnsToKeep)) {
                    return null; // NULL removes the field
                }
                return undefined; // UNDEFINED keeps the field
            },
        },
        SelectionSet(selectionSet) {
            if (!insideResults) {
                return undefined;
            }
            // Filter out null selections
            const filteredSelections = selectionSet.selections.filter((selection) => selection !== null);
            if (filteredSelections.length === 0) {
                return null; // Remove empty selection sets
            }
            return Object.assign(Object.assign({}, selectionSet), { selections: filteredSelections });
        },
    }));
}
